import React from 'react';

function Learning_30062025() {
  const shoot = () => {
    alert("Great Shot!");
  };

  return (
    <button onClick={shoot}>Take the shot!</button>
  );
}

export default Learning_30062025;
